import { API } from '@/inc/api';
import { _st } from '@/softech';
import { bus } from '@/main';

export const ambassadors = {
    namespaced: true,
    state: {
        ambassadors     : [],
        needRefresh     : true,
        hasMore         : true,
        page            : 0,
        perPage         : 200,
    },
    mutations: {
        setAmbassadors( state, payload ) {
            if( state.needRefresh ) {
                state.ambassadors = payload;
            }
            else {
                payload.forEach(c => {
                    state.ambassadors.push(c);
                });
            }
        },
        setNeedRefresh( state, payload ) {
            state.needRefresh = payload;
        },
        setHasMore( state, payload ) {
            state.hasMore = payload;
        },
        setPage( state, payload ) {
            state.page = payload;
        }
    },
    actions: {
        async loadAmbassadors({ commit, state }) {
            if( !state.needRefresh && !state.hasMore ) {
                return Promise.resolve();
            }

            try {
                let api = new API();
                let offset = state.page * state.perPage;
                offset = offset == 0 ? 0 : offset + 1;

                let res = await api.get(`/admin/ambassadors/${offset}/${state.perPage}`);

                if( !res.data.status ) {
                    bus.$emit('alert', { 
                        text    : res.data.message, 
                        color   : res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject( false );
                }

                commit('setAmbassadors', res.data.data);
                commit('setNeedRefresh', false);
                commit('setHasMore', res.data.data.length == state.perPage);
                commit('setPage', state.page + 1);
                return Promise.resolve();
            }
            catch(error) {
                return Promise.reject(error);
            }
        },
        async saveAmbassador({ commit }, ambassador) {
            try {
                let api = new API();
                let res = null;
                
                if( _st.isNUE( ambassador.id ) )
                    res = await api.post('/admin/ambassador', ambassador );
                else
                    res = await api.put('/admin/ambassador', ambassador );

                if( !res.data.status ) {
                    return Promise.resolve( res.data );
                }

                commit('setNeedRefresh', true);
                return Promise.resolve( res.data );
            }
            catch(error) {
                return Promise.reject(error);
            }
        }
    },
    getters: {
        ambassadors     : (state) => state.ambassadors,
        needRefresh     : (state) => state.needRefresh,
        hasMore         : (state) => state.hasMore,
        page            : (state) => state.page
    }
}